//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The template preview event model
* 
* @param beginsAt The date and time when the event begins
* @param eventId The event id
* @param eventTitle The localized event title
* @param venueName The venue name
* @param blurHash Sets the blur hash
* @param city The city
* @param endsAt The date and time when the event ends
* @param eventSubTitle The localized subtitle of the event
* @param previewUrl The preview url -> needed?
*/
@Serializable

data class PreviewEvent (


      /* The date and time when the event begins */
    @SerialName(value = "beginsAt") @Required val beginsAt: kotlin.time.Instant,


      /* The event id */
    @SerialName(value = "eventId") @Required val eventId: kotlin.Int,


      /* The localized event title */
    @SerialName(value = "eventTitle") @Required val eventTitle: kotlin.String,


      /* The venue name */
    @SerialName(value = "venueName") @Required val venueName: kotlin.String,


      /* Sets the blur hash */
    @SerialName(value = "blurHash") val blurHash: kotlin.String? = null,


      /* The city */
    @SerialName(value = "city") val city: kotlin.String? = null,


      /* The date and time when the event ends */
    @SerialName(value = "endsAt") val endsAt: kotlin.time.Instant? = null,


      /* The localized subtitle of the event */
    @SerialName(value = "eventSubTitle") val eventSubTitle: kotlin.String? = null,


      /* The preview url -> needed? */
    @Deprecated(message = "This property is deprecated.")
    @SerialName(value = "previewUrl") val previewUrl: kotlin.String? = null


) {




  }

